export const KEVEL_ID = 'kevel_id';
export const SPONSORED_CLICK_URL = 'sponsored_click_url';
export const SEARCH_SUGGESTION_PRODUCT = 'search_suggestion_product';
export const SEARCH_RESULT_PAGE_PRODUCTS = 'search_result_page_products';
